import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { variants } from 'classname-variants';

const BUTTON_VARIANTS = {
  primary: 'bg-black text-white px-6 px-4 tablet:px-5 desktop:px-6 hover:bg-opacity-60',
  secondary:
    'bg-primaryRed ring-primaryRed text-white hover:bg-[#B90000] px-4 tablet:px-5 desktop:px-6',
  alternate:
    'hover:bg-black hover:opacity-100 hover:text-white border border-black px-4 tablet:px-5 desktop:px-6',
  white:
    'bg-white text-black px-4 tablet:px-5 desktop:px-6',
  underline: 'underline-offset-2 underline',
  text: '',
  icon: 'aspect-square',
};

const BUTTON_SIZES = {
  small: 'h-8 w-8 min-w-8',
  medium: 'h-10',
  large: 'h-[43px] rounded-[120px]',
};
// Currently remove for text buttons(base class)
//focus:ring-2 focus-visible:ring-2
const BUTTON_VARIANTS_MERGE = variants({
  base: 'gap-x-1 w-full rounded-full whitespace-nowrap flex items-center justify-center cursor-pointer transition duration-300 disabled:opacity-50 ? b disabled:cursor-not-allowed font-semibold outline-offset-4 outline-none focus:outline-none  focus-visible:underline ring-offset-2 px-1.5 ring-black',
  variants: {
    variant: BUTTON_VARIANTS,
    size: BUTTON_SIZES,
    isLoading: {
      true: 'bg-opacity-50 pointer-events-none h-9 flex items-center justify-center',
      false: '',
    },
    padding: {
      true: 'px-4 py-2',
      false: '',
    },
  },
});
export type ButtonVariant = keyof typeof BUTTON_VARIANTS;
export type ButtonSize = keyof typeof BUTTON_SIZES;

@Component({
  selector: 'sc-button',
  standalone: true,
  imports: [NgClass, RouterLink, NgTemplateOutlet],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  clicked = output<MouseEvent>();

  variant = input<ButtonVariant>('primary');
  size = input<ButtonSize>('medium');
  padding = input<boolean>(false);
  type = input<'button' | 'submit' | 'reset'>('button');
  class = input<string>('');

  url = input<string>(null);
  relativeUrl = input<string>(null);
  isNewTab = input<boolean>(true);

  disabled = input<boolean>(null);

  ariaLabel = input<string>(null);
  ariaHasPopup = input<boolean>(false);
  role = input<string>(null);
  ariaLive = input<string>(null);

  public get className() {
    return (
      BUTTON_VARIANTS_MERGE({
        variant: this.variant(),
        size: this.size(),
        padding: this.padding(),
      }) +
      ' ' +
      this.class()
    );
  }
}
